import { createSelector } from 'reselect';

import { Store } from '../reducers/reducers';

const getAuthentication = (store: Store) => store.authentication;

const authenticationTokenSelector = createSelector(getAuthentication, (authentication) => authentication.token);
export default authenticationTokenSelector;

export const loggedInUserSelector = createSelector(getAuthentication, (authentication) => authentication.loggedInUser);

export const getLoggedInUserSelector = createSelector(loggedInUserSelector, (user) => {
  if (user === null) throw Error('Cannot get logged in user');
  return user;
});

export const authenticationFailedSelector = createSelector(getAuthentication, (authentication) => authentication.authenticationFailed);

export const placePermissionsSelector = createSelector(getLoggedInUserSelector, (loggedInUser) => loggedInUser.placePermissions);
